import React, {useEffect} from "react";
import './AnalizaMain.css';
import TeX from "@matejmazur/react-katex";
import MathJax from 'react-mathjax-preview';
import * as BiIcons from "react-icons/bi";
import {useHistory} from "react-router-dom";

export default function LiczbyZespolone(){

	useEffect(()=>{
		document.title="Liczby zespolone";
	},[])

	const { push } = useHistory();

	const comeBackFunc=()=>{
		push('/analiza');
	}

	return(
		<div className='conceptsContainer'>
			<div className='comeBackDiv' onClick={comeBackFunc}>
				<BiIcons.BiArrowBack/>
				<div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
			</div>

			<h1>Liczby zespolone</h1>
			<p>Liczby zespolone są rozszerzeniem liczb rzeczywistych.</p>
			<br/>
			<p>Główną różnicą między liczbami rzeczywistami, a zespolonymi jest to, że u liczb zespolonych można wyciągnąć pierwiastek
			z liczb ujemnych, kiedy u liczb rzeczywistych jest to niemożliwe. Taki pierwiastek jest liczbą tzw. liczbą urojoną,
			i zapisujemy go za pomocą jednostki urojonej <TeX math={'i'}/>, którą definiujemy: </p>
			<p><TeX math={'i^2=-1'}/>.</p>
			<p>Przykład:</p>
			<p><TeX math={'x^2=-36'}/></p>
			<p><MathJax math={'`x=-6i &#8744; x=6i`'}/></p>
			<p><TeX math={'(-6i)^2=36i^2=-36'}/></p>
			<p><TeX math={'(6i)^2=36i^2=-36'}/></p>
			<br/><br/>

			<p>Liczby zespolone możemy zapisać jako sumę: <TeX math={'z=x+iy'}/> lub jako uporządkowaną parę <TeX math={'(x,y)'}/>,
				(x, y - liczby rzeczywiste).</p>
			<p className='oneLine centerVertical'>Część rzeczywistą liczby zespolonej <TeX math={'z'}/>
				oznaczamy symbolem &nbsp;&nbsp;<MathJax math={'`Re(z)`'}/>&nbsp;&nbsp;
				a część urojoną oznaczamy &nbsp;&nbsp;<MathJax math={'`Im(z)`'}/>.</p>

			<p>Przykład:</p>
			<p className='oneLine centerVertical'>1)&nbsp;&nbsp;<MathJax math={'`Re(5+25i)=5`'}/></p>
			<p><MathJax math={'`Im(5+25i)=25`'}/></p><br/>
			<p className='oneLine centerVertical'>2)&nbsp;&nbsp;<MathJax math={'`Re(2+sqrt(7))=2+sqrt(7)`'}/></p>
			<p><MathJax math={'`Im(2+sqrt(7))=0`'}/></p><br/>
			<p className='oneLine centerVertical'>3)&nbsp;&nbsp;<MathJax math={'`Re(10i)=0`'}/></p>
			<p><MathJax math={'`Im(10i)=10`'}/></p><br/>




			<h4>Jeśli chodzi o dodawanie, odejmowanie, mnożenie i dzielenie, to stosujemy te same reguły, jak dla liczb rzeczywistych,
				z wyjątkiem iloczynu <TeX math='i^2=-1'/>.
			</h4>
			<br/><br/>
			<p>Kilka przykładów:</p>

			<p>Przykład:</p>
			<p className='oneLine centerVertical'>1)&nbsp;&nbsp;<MathJax math={'`(6+8i)+(3-2i)=9+6i`'}/></p>
			<p className='oneLine centerVertical'>2)&nbsp;&nbsp;<MathJax math={'`(6+8i)cdot(3-2i)=-16i^2+12i+18=2+12i`'}/></p>
			<p className='oneLine centerVertical'>3)&nbsp;&nbsp;<MathJax math={'`i^15=(i^2)^7cdoti=(-1)^7cdoti=-i`'}/></p>
			<p className='oneLine centerVertical'>4)&nbsp;&nbsp;<MathJax math={'`i^28=(i^2)^14=(-1)^14=1`'}/></p>
			<p className='oneLine centerVertical'>5)&nbsp;&nbsp;<MathJax math={'`(i^2+i^3+i^4)^11=(-1-i+1)^11=-i`'}/></p>
			<br/><br/><br/>
			<h2>Liczby sprzężone</h2>
			<p><span className='italic'>Liczbą sprzężoną</span> nazywamy liczbę zespoloną różniącą się od liczby <TeX math={'z=a+bi'}/>
				tylko znakiem współczynnika przy <TeX math={'i'}/>, i oznaczamy ją <MathJax math={'`barz=a-bi`'}/>
			</p>
			<p>Przykład:</p>
			<p className='oneLine centerVertical'>1)&nbsp;&nbsp;<MathJax math={'`z=12+7i&nbsp;=>&nbsp;barz=12-7i`'}/></p>
			<p className='oneLine centerVertical'>2)&nbsp;&nbsp;<MathJax math={'`z=sqrt(7)+9i&nbsp;=>&nbsp;barz=sqrt(7)-9i`'}/></p>
			<br/><br/>
			<h3>Własności liczb sprzężonych:</h3>
			<p className='oneLine centerVertical'>1) &nbsp;&nbsp;<MathJax math={'`z+barz=2Re(z)`'}/></p>
			<p className='oneLine centerVertical'>2) &nbsp;&nbsp;<MathJax math={'`bar(z_1+z_2)=bar(z_1)+bar(z_2)`'}/></p>
			<p className='oneLine centerVertical'>3) &nbsp;&nbsp;<MathJax math={'`zcdotbarz=|z|^2`'}/>, gdzie
				&nbsp;<MathJax math={'`z=a+bi`'}/>,&nbsp;&nbsp;<MathJax math={'`|z|=sqrt(a^2+b^2)`'}/></p>
			<br/>
			<p className='oneLine centerVertical'><MathJax math={'`|z|=sqrt(a^2+b^2)&nbsp;`'}/> nazywamy modułem liczby &nbsp;
				<TeX math={'z'}/>.</p>
			<br/>
			<p>W przykładach obliczymy moduł liczby <TeX math={'z'}/>:</p>
			<p className='oneLine centerVertical'>1)&nbsp;&nbsp;<TeX math={'z=8+3i'}/></p>
			<p className='oneLine centerVertical'><MathJax math={'`|z|=sqrt(8^2+3^2)=sqrt(73)`'}/></p><br/>
			<p className='oneLine centerVertical'>2)&nbsp;&nbsp;<TeX math={'z=4-3i'}/></p>
			<p className='oneLine centerVertical'><MathJax math={'`|z|=sqrt(4^2+(-3)^2)=5`'}/></p><br/>
			<p className='oneLine centerVertical'>3)&nbsp;&nbsp;<TeX math={'z=4i'}/></p>
			<p className='oneLine centerVertical'><MathJax math={'`|z|=sqrt(0^2+4^2)=4`'}/></p><br/>
			<br/><br/>
			<h3>Własności modułu:</h3>
			<p className='oneLine centerVertical'>1)&nbsp;&nbsp;<MathJax math={'`zcdotbarz=|z|^2`'}/> </p>
			<p className='oneLine centerVertical'>2)&nbsp;&nbsp;<MathJax math={'`|z_1cdotz_2|=|z_1|cdot|z_2|`'}/> </p>
			<p className='oneLine centerVertical'>3)&nbsp;&nbsp;<MathJax math={'`|z_1+z_2|&#8804;|z_1|+|z_2|`'}/> </p>
			<br/><br/><br/>
			<h2>Interpretacja geometryczna liczby zespolonej</h2>
			<h5>Rysunki(2)</h5>

		</div>
	);
}